import { TableData } from '@models/table-data';

// table data for Handyversicherung landing page
export const insuranceComparison: TableData = {
    subtitles: ['Leistung', 'Handy', 'Hausrat', 'Haftpflicht'],
    collapsedTitle: 'Handyversicherung vs. Hausrat- / Haftpflichtversicherung',
    rows: [
        {
            title: 'Eigenschäden',
            cells: [
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: false, value: '' },
            ],
        },
        {
            title: 'Wasser, Brand',
            cells: [
                { type: 'check', checkmark: true, value: '' },
                { type: 'text', value: 'Nur bei Rohrbruch zuhause' },
                { type: 'check', checkmark: false, value: '' },
            ],
        },
        {
            title: 'Diebstahl',
            cells: [
                { type: 'check', checkmark: true, value: '' },
                { type: 'text', value: 'Nur zuhause' },
                { type: 'check', checkmark: false, value: '' },
            ],
        },
        {
            title: 'Beschädigung durch Dritte',
            cells: [
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: true, value: '' },
            ],
        },
        {
            title: 'Weltweit',
            cells: [
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: false, value: '' },
            ],
        },
    ],
    highlighted: 0,
};
